// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"192":"fb6b17ae","402":"94e33a9e","871":"ee6d8f66","873":"f98bced1","980":"b94f89df"}[chunkId] + ".css";
};